<script lang="ts" setup>
import LoadingIcon from '@/components/icons/IconLoading.vue';

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    loading?: boolean;
    secondary?: boolean;
    fullWidth?: boolean;
  }>(),
  {
    disabled: false,
    loading: false,
    secondary: false,
    fullWidth: false,
  }
);

const emit = defineEmits<{ click: [] }>();

const clickButton = () => {
  if (props.loading) {
    return;
  }
  emit('click');
};
</script>

<template>
  <button
    :class="[
      'l-btn',
      // fullWidth && 'button-full-width',
      secondary ? 'gray-btn' : 'primary-btn',
    ]"
    :disabled="loading || disabled"
    :aria-busy="loading ? 'true' : 'false'"
    @click.prevent="clickButton"
  >
    <slot v-if="!loading" />
    <LoadingIcon v-else size="1.5rem" fill-color="var(--font-white)" />
  </button>
</template>

<style scoped lang="scss">
.btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-loading {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}

.invisible {
  visibility: hidden;
}
</style>
